{
  "renderer": {
    "submit": "Submit",
    "submitting": "Submitting…",
    "yes": "Yes",
    "select": "Select…",
    "fileUploadUnavailable": "File upload is not available yet.",
    "upload": {
      "uploading": "Uploading…",
      "finalizing": "Finalizing…",
      "cancel": "Cancel",
      "replace": "Replace",
      "remove": "Remove",
      "noFile": "No file attached.",
      "interrupted": "A previous upload didn't finish. Please choose the file again.",
      "failedPersisted": "\"{{filename}}\" failed to upload. Please choose the file again.",
      "allowedTypes": "Allowed file types: {{extensions}}",
      "errors": {
        "extensionNotAllowed": "That file type isn't allowed. Accepted: {{extensions}}",
        "tooLarge": "This file is too large.",
        "tooLargeForNow": "Files over 100MB aren't supported yet; please use a smaller file.",
        "locked": "This submission is locked and its files can no longer be changed.",
        "deadlinePassed": "The submission deadline has passed.",
        "generic": "Upload failed. Please try again.",
        "genericWithDetail": "Upload failed: {{detail}}"
      }
    }
  },
  "types": {
    "registrationForm": {
      "label": "Registration form",
      "description": "Collected when a team registers for the competition — e.g. category, topic, declarations. A member's own enrollment proof belongs under \"Eligibility review\", not this form."
    },
    "teamForm": {
      "label": "Team form",
      "description": "Collected about the team itself, separate from its members. A member's enrollment status or proof should not go here — manage it under \"Eligibility review\" instead."
    },
    "submissionForm": {
      "label": "Submission form",
      "description": "What a team fills in alongside their entry's files."
    },
    "judgeConflictForm": {
      "label": "Judge conflict form",
      "description": "Lets a judge declare a conflict of interest before scoring."
    }
  },
  "fieldTypes": {
    "short_text": "Short text",
    "long_text": "Long text",
    "rich_text": "Rich text",
    "number": "Number",
    "email": "Email",
    "phone": "Phone",
    "url": "URL",
    "date": "Date",
    "datetime": "Date & time",
    "radio": "Single choice",
    "checkbox": "Checkbox",
    "select": "Dropdown",
    "multi_select": "Multiple choice",
    "boolean": "Yes/No",
    "file": "File",
    "image": "Image",
    "pdf": "PDF file",
    "zip": "ZIP archive",
    "heading": "Heading (layout)",
    "description": "Description text (layout)",
    "separator": "Divider (layout)"
  },
  "eligibilityPointer": {
    "text": "If this competition requires student eligibility verification, manage the requirement and review rules from Overview.",
    "cta": "Manage student eligibility requirements →"
  }
}
